export const SITE_NAME = 'PaisaWise';

export const DEFAULT_TITLE = 'Wealth Management & Financial Planning';

export const DEFAULT_DESCRIPTION =
  'PaisaWise — financial wisdom, retirement planning guides, and free calculators for Indian investors.';

export function getSiteOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return String(process.env.REACT_APP_SITE_URL || 'https://paisawise.co.in').replace(/\/$/, '');
}

export function resolveAbsoluteUrl(url) {
  if (!url) return undefined;
  if (/^https?:\/\//i.test(url)) return url;
  const base = getSiteOrigin();
  return `${base}${url.startsWith('/') ? url : `/${url}`}`;
}

export function formatPageTitle(title) {
  if (!title) return `${SITE_NAME} - ${DEFAULT_TITLE}`;
  if (title.includes(SITE_NAME)) return title;
  return `${title} | ${SITE_NAME}`;
}

export function buildCanonicalUrl(pathname) {
  return `${getSiteOrigin()}${pathname}`;
}
